export default __webpack_public_path__ + "static/s4-bc3a44f5d6d1b80396fcae644a905695.jpg";